var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { parseFieldAddress } from './address';
var MAX_ADDRESS_SUGGESTIONS = 12;
/** A partial address: one to three tag characters, optionally a subfield code. */
var PARTIAL_ADDRESS = /^[0-9xX]{1,3}$|^[0-9xX]{3}[a-z0-9]?$/;
var addressItem = function (address, label) { return ({
    kind: 'field',
    label: label ? "".concat(address, " ").concat(label) : address,
    insertText: address,
}); };
/**
 * CZNA-217 — field suggestions by MARC address. The registry resolves addresses
 * dynamically, so the TSL core cannot list them; this replaces its field items with:
 *
 * - while a tag is being typed (`15`) — the catalog tags it starts, with their labels;
 * - once a known tag is complete (`150`) — the tag itself and its subfields (`150a`);
 * - a catalog name matched by the core (`Oblast…`) — inserted as its tag, because the
 *   labels carry parentheses that would not parse back.
 */
export var createAddressSuggestions = function (catalog, registry) {
    return function (result, context) {
        // Addresses belong at the start of a clause only — never at an operator or value
        // position, where `1945` is a value and not field 194, subfield 5.
        var atClauseStart = result.valueContext === undefined
            && result.items.every(function (item) { return item.kind === 'field' || item.kind === 'pseudoField' || item.kind === 'connector'; });
        if (!atClauseStart) {
            return result;
        }
        var prefix = context.text.slice(result.replaceRange.start, context.caret);
        var fieldItems = result.items.filter(function (item) { return item.kind === 'field'; });
        var otherItems = result.items.filter(function (item) { return item.kind !== 'field'; });
        if (fieldItems.length === 0 && !PARTIAL_ADDRESS.test(prefix)) {
            return result;
        }
        var addressItems = [];
        if (PARTIAL_ADDRESS.test(prefix)) {
            var address_1 = parseFieldAddress(prefix);
            var exact_1 = address_1 && catalog.fields.find(function (field) { return field.tag === address_1.field; });
            if (exact_1) {
                addressItems = __spreadArray([
                    addressItem(exact_1.tag, exact_1.label)
                ], exact_1.subfields
                    .filter(function (subfield) { return !address_1.subfield || subfield.code.startsWith(address_1.subfield); })
                    .map(function (subfield) { return addressItem("".concat(exact_1.tag).concat(subfield.code), subfield.label); }), true);
            }
            else {
                var upper_1 = prefix.toUpperCase();
                addressItems = catalog.fields
                    .filter(function (field) { return upper_1.split('').every(function (char, index) { return char === 'X' || field.tag[index] === char; }); })
                    .map(function (field) { return addressItem(field.tag, field.label); });
            }
        }
        else {
            // Items the core matched by catalog name: re-point them at the tag.
            addressItems = fieldItems.map(function (item) {
                var field = registry.fields.find(function (candidate) { return candidate.label === item.label; });
                return (field === null || field === void 0 ? void 0 : field.key) ? addressItem(field.key, field.label) : item;
            });
        }
        // Only the top-level (clause start) suggestion list carries field items; keep the
        // pseudo field (`Typ`) and connectors after the addresses.
        return __assign(__assign({}, result), { items: __spreadArray(__spreadArray([], addressItems.slice(0, MAX_ADDRESS_SUGGESTIONS), true), otherItems, true) });
    };
};
